// @ts-nocheck
import { CommodityI } from "../../config/listOptions";
import { setFormatDate } from "../../utils/parseData";
import { ApprovalFiltersI,
  ApprovalStatusFiltersI,
  CarrierI,
  EquipmentTypeI,
  LocationI,
  StatusTypes } from "./approvalsTypes";

export const parseLocationsForpayload = (locations: Array<LocationI>) => locations.map((location) => `${location.city || ""}, ${location.state_id}`);

export const parseEquipmentsForPayload = (equipments: Array<EquipmentTypeI>) =>
  equipments.map((equipment) => equipment.equipment_code);

export const parseCommoditiesForPayload = (commodities: Array<CommodityI>) => commodities.map((elem) => elem.description);
export const parseCarriersForPayload = (commodities: Array<CarrierI>) => commodities.map((elem) => elem.carrier_id);

export const validateApprovalsFilters = (filters: ApprovalFiltersI) => {
  if (filters.distance?.id && !filters.distance_from?.id) return "A from option should be selected if Radius Distance option is selected";
  if (!filters.distance?.id && filters.distance_from?.id) return "A Distance option should be selected if a Radius From option is selected";
  if (filters.distance?.id && filters.distance_from?.id === "ORIGIN" && !filters.origin) return `A Shipper Location should be selected if Radius From has the option 'Origin' selected`;
  if (filters.distance?.id && filters.distance_from?.id === "DESTINATION" && !filters.destination) return `A Receiver Location should be selected if Radius From has the option 'Destinaton' selected`;
  if (filters.distance?.id && filters.distance_from?.id === "BOTH" && (!filters.origin || !filters.destination)) return `Shipper and Receiver Locations should be selected if Radius From has the option 'Both' selected`;

  return "";
};

export const parseFilterPayload = (filters: ApprovalFiltersI): any => {
  const temp: any = { ...filters };

  if (filters?.sort_by?.id) temp.sort_by = filters?.sort_by?.id;
  if (filters.distance?.id) temp.distance = filters?.distance?.id;
  if (filters.distance_from?.id) temp.distance_from = filters?.distance_from?.id;
  if (filters.origin?.length) temp.origin = parseLocationsForpayload(filters.origin);
  if (filters.destination?.length) temp.destination = parseLocationsForpayload(filters.destination);
  if (filters.equipment_type?.length) temp.equipment_type = parseEquipmentsForPayload(filters.equipment_type);
  if (filters.commodity?.length) temp.commodity = parseCommoditiesForPayload(filters.commodity);
  if (filters.carrier?.length) temp.carrier = parseCarriersForPayload(filters.carrier);
  if (filters.salesperson?.salesperson_id) temp.salesperson = filters.salesperson.salesperson_id;
  if (filters.pick_up_date) temp.pick_up_date = setFormatDate(filters.pick_up_date, "YYYY-MM-DD");
  if (filters.drop_off_date) temp.drop_off_date = setFormatDate(filters.drop_off_date, "YYYY-MM-DD");
  if (filters.dispatcher) temp.dispatcher = filters.dispatcher.dispatcher;
  if (filters.dispatch_division) {
    temp.dispatch_division_id = filters.dispatch_division.dispatch_division_id;
    delete temp.dispatch_division;
  }

  return temp;
};

export const atLeastOneField = (values: ApprovalFiltersI): boolean =>
  Boolean(
    (values.equipment_type && values.equipment_type?.length > 0)
      || (values.commodity && values.commodity?.length > 0)
      || (values.carrier && values.carrier?.length > 0)
      || (values.origin && values.origin?.length > 0)
      || values.pick_up_date
      || (values.destination && values.destination?.length > 0)
      || values.drop_off_date

      || (values.distance?.id && values.distance?.id?.length > 0)

      || (values.distance_from?.id && values.distance_from?.id?.length > 0)
      || values.order_number
      || (values.dispatcher && values.dispatcher.dispatcher)
      || values.dispatch_division

      || (values.dispatch_division && values.dispatch_division?.dispatch_division_id),
  );

export const checkStatusField = (values: ApprovalStatusFiltersI): boolean => Boolean(values.status);

export const getApprovalStatusColor = (theme: any, status?: StatusTypes) => {
  const statusType = {
    approved : theme.LA_PALMA,
    rejected : theme.RED_ORANGE,
    counter  : theme.ORANGE,
    expired  : theme.RED_ORANGE,
    default  : theme.BLACK,
  };

  return status ? statusType[status] : statusType.default;
};
export type MarketScoreMappedItemI = {
  text: string;
  minValue: number;
  maxValue: number;
  color: string;
}
const marketScoresTextValues: Array<MarketScoreMappedItemI> = [
  { text: "- -", minValue: 0, maxValue: 0, color: "DOVE_GRAY" },
  { text: "Extremely Loose", minValue: 1, maxValue: 20, color: "GUARDSMAN_RED" },
  { text: "Loose", minValue: 21, maxValue: 40, color: "JAFFA" },
  { text: "Moderate", minValue: 41, maxValue: 60, color: "BUDDHA_GOLD" },
  { text: "Tight", minValue: 61, maxValue: 80, color: "LIMA" },
  { text: "Extremely Tight", minValue: 81, maxValue: 100, color: "FUN_GREEN" },
];

export const getTextFromMarketScore = (marketScoreValue: number): MarketScoreMappedItemI => {
  const resultIndex = marketScoresTextValues.findIndex(
    (market) => market.minValue <= marketScoreValue && market.maxValue >= marketScoreValue,
  );

  return resultIndex !== -1 ? marketScoresTextValues[resultIndex] : marketScoresTextValues[0];
};
